import { i18n } from 'boot/i18n';

import GenericDB from './generic-db';

export default class WorkflowsDB extends GenericDB {
  constructor() {
    super('workflows');
  }

  /**
   * Toggle lock state of selected worklflow
   * @param {string} id
   * @param {boolean} isLocked current field status
   */
  toggleWorkflowLock(id, isLocked) {
    return this.set({ isLocked: !isLocked }, id);
  }

  duplicateWorkflow(workflow) {
    const formattedWorkflow = {
      ...workflow,
      workflowName: `${workflow.workflowName} (${i18n.t('common.buttonCopy')})`,
    };
    return this.create(formattedWorkflow);
  }
}
